module.exports = __webpack_public_path__ + "static/media/kotak-life-insurance.3e0a1e36.svg";